import gsap from 'gsap';
import { ScrollTrigger } from 'gsap/all';

export default function rightChoice() {
	let isStatsVisilble = false;
	const target = document.querySelector('.cyntexa-right-choice');
	function handleIntersection(entries) {
		entries.map((entry) => {
			if (entry.isIntersecting) {
				if (!isStatsVisilble) {
					isStatsVisilble = true;
					document
						.querySelectorAll('.stats')
						.forEach(function (element) {
							var countTo = parseInt(
								element.getAttribute('data-stats'),
							);
							var countNum = parseInt(element.textContent);

							var duration = 3000;
							var startTime = null;

							function animate(timestamp) {
								if (!startTime) startTime = timestamp;
								var progress = timestamp - startTime;
								var increment = (countTo / duration) * progress;

								if (progress < duration) {
									element.textContent = Math.floor(
										countNum + increment,
									);
									requestAnimationFrame(animate);
								} else {
									element.textContent = countTo;
								}
							}

							requestAnimationFrame(animate);
						});
				}
			}
		});
	}
	const observer = new IntersectionObserver(handleIntersection);

	observer.observe(target);

	let sections = gsap.utils.toArray('.cyntexa-right-choice .box');
	let boxes = document.querySelector('.cyntexa-right-choice .boxes');
	let picture = document.querySelector('.cyntexa-right-choice .picture');

	gsap.matchMedia().add('(min-width: 65.625em)', () => {
		let rightChoice = gsap.timeline({
			scrollTrigger: {
				trigger: '.cyntexa-right-choice',
				start: 'center center',
				end: () => picture.offsetHeight + boxes.offsetWidth + 'bottom',
				scrub: true,
				pin: '.cyntexa-right-choice',
				pinSpacing: true,
				pinType: 'fixed',
			},
		});

		rightChoice
			.fromTo(
				'.cyntexa-right-choice .picture',
				{
					width: '100%',
				},
				{
					width: '600px',
					height: '300px',
					duration: 1,
					scrollTrigger: {
						end: () => '+=' + picture.clientHeight,
					},
					onComplete: function () {
						let video = document.querySelector(
							'.cyntexa-right-choice video',
						);
						video.play();
						video.style.opacity = 1;
					},
				},
			)
			.to(
				sections,
				{
					duration: 3,
					xPercent: -100 * sections.length,
					onReverseComplete: function () {
						let video = document.querySelector(
							'.cyntexa-right-choice video',
						);
						video.pause();
						video.style.opacity = 0;
					},
				},
				'>',
			);
	});

	gsap.matchMedia().add('(max-width: 65.625em)', () => {
		let container = document.querySelector(
			'.cyntexa-right-choice .container',
		);
		let rightChoice = gsap.timeline({
			scrollTrigger: {
				trigger: '.cyntexa-right-choice',
				start: 'center+=100px center',
				end: () => boxes.offsetWidth + 'bottom',
				scrub: true,
				pin: '.cyntexa-right-choice',
				pinSpacing: true,
				pinType: 'fixed',
				onLeaveBack: function () {
					let video = document.querySelector(
						'.cyntexa-right-choice video',
					);
					video.pause();
					video.style.opacity = 0;
				},
			},
		});

		rightChoice.to(
			sections,
			{
				onStart: function () {
					let video = document.querySelector(
						'.cyntexa-right-choice video',
					);
					video.play();
					video.style.opacity = 1;
				},
				duration: 3,
				xPercent: -110 * (sections.length - 1),
			},
			'>',
		);
	});
}
